import { Component, OnInit, Output, EventEmitter, TemplateRef, ViewChild, Input, QueryList, ViewChildren } from '@angular/core';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { CommonService } from '../../shared/providers/common.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ISaveSearchInputModel } from '../../shared/models/SaveSearchInputModel';
import { ToastService } from '../../shared/providers/toast.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ResultOutputModel } from '../../shared/models/resultOutputModel';
import { PropertyFor, LookUp } from '../../shared/enum/enum';
import { SharedService } from '../../shared/providers/shared.service';
/*import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';*/
import { environment } from '../../../environments/environment';
import { catchError, concat, debounceTime, delay, distinctUntilChanged, filter, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { MatSelect } from '@angular/material/select';
import { async } from 'rxjs';
import { ICities } from '../../shared/models/CitiesListOutputModel';

interface IFilterTag {
  Id: number;
  Value: string
}

interface ItableState {
  TableName: string;
  TableState: any;
  IsSortOrderChanged: boolean;
}

export enum Sort {
  PriceLowHigh = "PLH",
  PriceHighLow = "PHL",
  TenantAtoZ = "TAZ",
  TenantZtoA = "TZA",
  //Rank = 'RNK'
  Rank = 'PHL'
}

@Component({
  selector: 'be-property-search',
  templateUrl: './property-search.component.html'
})

export class PropertySearchComponent implements OnInit {

  @Output() propertySearchCriteria = new EventEmitter<IPropertySearchCriteria>();
  @Output() loadSaveSearch = new EventEmitter<void>();
  @Output() saveSearchEmitter = new EventEmitter();
  @ViewChild('select') select: MatSelect;
  searchCriteria = {} as IPropertySearchCriteria;
  inputAssetTypes = [];
  originalAssetTypes: any[] = [];
  inputRatings = [];
  inputTenants = [];
  inputTerms = [];
  inputPropertyStatus = [];
  propertyStatusCalled: boolean = false;
  inputStates = [];
  inputLeaseStructure = [];
  inputSubCategory = [];
  inputOwnershipStructure = [];
  characteristicList = [];
  isUserLoggedIn: boolean = false;
  saveSearchInputModel = {} as ISaveSearchInputModel;
  search = '';
  user: any;
  saveSearchResponse = {} as ResultOutputModel;
  canShowsavedSearch = false;
  rentEscalationLabel = "$";
  IsValid: boolean = false;
  rentInvalid: boolean = false;
  buildsizeInvalid: boolean = false;
  yearbuiltInvalid: boolean = false;
  caprateInvalid: boolean = false;
  rentescalationInavlid: boolean = false;
  percentageInvalid: boolean = false;
  priceInValid: boolean = false;
  rentValidation: string = "";
  buildsizeValidation: string = "";
  yearbuiltValidation: string = "";
  caprateValidation: string = "";
  rentescalationValidation: string = "";
  priceValidation: string = "";
  @ViewChild('dropdownTenants') dropdownTenants: any;
  @ViewChild('dropdownState') dropdownState: any;
  @ViewChildren(MatSelect) matSelects: QueryList<MatSelect>;
  propertyDataService: [];/*CompleterData;*/
  protected readonly BASE_URL: string = environment.base_url;
  protected readonly Site_URL: string = environment.siteurl + '/propertylisting?request=buy&search=';
  isCollapsed = false;
  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  dataTenantService$: Observable<any[]>;
  dataTenantServiceInput$ = new Subject<string>();
  AddressService$: Observable<any[]>;
  AddressServiceInput$ = new Subject<string>();
  searchPropertyType: string = '';
  loading = false;
  selectedAssetTypes: any[] = [];
  //defaultTypeText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Property Type'
  //};
  //defaultCharacteristicsText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Property Characteristics'
  //};
  defaultTypeSettings = {
    idField: 'id',
    textField: 'itemName',
    singleSelection: false,
    text: "Property Type",
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1,
    enableCheckAll: false, // Disables "Select All"
    enableUncheckAll: false
  }
  defaultCharacteristicsSettings = {
    singleSelection: false,
    text: "Property Characteristics",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  }

  defaultTenantSettings = {
    singleSelection: false,
    text: "Tenant",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1,
    enableSearchFilter: true
  };

  defaultCreditSettings = {
    bindvalue: 'id',
    bindlabel: 'itemName',
    singleSelection: false,
    text: "Rating",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  defaultTermSettings = {
    singleSelection: false,
    text: "Term",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  defaultStateSettings = {
    bindvalue: 'id',
    bindlabel: 'itemName',
    singleSelection: false,
    text: "- Select -",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1,
    enableSearchFilter: true,
  };

  defaultLeaseStructureSettings = {
    bindvalue: 'id',
    bindlabel: 'itemName',
    singleSelection: false,
    text: "- Select -",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  defaultPropertyStatusSettings = {
    bindvalue: 'id',
    bindlabel: 'itemName',
    singleSelection: false,
    text: "- Select -",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  defaultSubCategorySettings = {
    bindvalue: 'id',
    bindlabel: 'itemName',
    singleSelection: false,
    text: "- Select -",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };

  defaultOwnershipStructureSettings = {
    bindvalue: 'id',
    bindlabel: 'itemName',
    singleSelection: false,
    text: "- Select -",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };
  isFav = false;
  isDisliked = false;
  sort = Sort;
  tableState: ItableState[] = [];
  isBackSpace: boolean = false;
  addressPreviousVal: string = '';

  constructor(private _propertyListingService: PropertyListingService, private _commonService: CommonService, public authService: AuthenticationService,
    private modalService: BsModalService, private _toastService: ToastService, /*private completerService: CompleterService, */private _validationService: ValidationService, private Shared: SharedService,
    private activatedRoute: ActivatedRoute, private router: Router, private propertyManagement: PropertyManagementService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.search = params['search'];
      this.isFav = params['isFav'] != undefined ? true : false;
      this.isDisliked = params['isDisliked'] != undefined ? true : false;
      if (this.search != undefined) {
        this._propertyListingService.getUserSavedSearchCriteria(this.search).subscribe((response: IPropertySearchCriteria) => {
          this.searchCriteria = response;
          this.searchCriteria.IsSavedSearch = true;
          this.bindSavedSearch();
          for (let i = 0; i <= 24; i++) {
            if (i == 1) {
              this.buildTags(null, i, this.searchCriteria.TenantAddress);

            }
            else {
              this.buildTags(null, i);

            }
          }
        });
      }
      else if (this.isFav) {
        this.defaultSearchCriteriaValues();
        this.searchCriteria.IsFavorite = true;
      }
      else if (this.isDisliked) {
        this.defaultSearchCriteriaValues();
        this.searchCriteria.IsDisliked = true;
      }
      else {
        this.searchCriteria.IsFavorite = false;
        this.searchCriteria.IsDisliked = false;
      }
    });


    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['request'] !== undefined) {
        this.fillPrevSearchCriteria = true;
      }
      else {
        this.fillPrevSearchCriteria = false;
      }
    });

  }
  isPageLoad: boolean = true;
  fillPrevSearchCriteria = false;
  prevSearchCriteria = {} as IPropertySearchCriteria;
  originalSearchCriteria = {} as IPropertySearchCriteria;

  ngOnInit() {
    this.searchCriteria.IsTileList = true;
    this.filterTags = [];
    if (this.search != undefined) {

    }
    else {
      this.user = this.authService.user;
      this.defaultSearchCriteriaValues();

      if (this._propertyListingService.criteria != undefined && this._propertyListingService.criteria.TakeCount != undefined) {
        this.searchCriteria = this._propertyListingService.criteria;
        this.searchCriteria.IsMapView = false;
        this.searchCriteria.IsTileList = true;
      }

      if (this.isFav) {
        this.defaultSearchCriteriaValues();
        this.searchCriteria.IsFavorite = true;
      }
      if (this.isDisliked) {
        this.defaultSearchCriteriaValues();
        this.searchCriteria.IsDisliked = true;
      }

      if ((this.searchCriteria.PropertyFor !== PropertyFor.Sale) && (this.searchCriteria.PropertyFor !== PropertyFor.Exchange1031)) {
        this.searchCriteria.PropertyFor = PropertyFor.Sale;
      }

      this.searchCriteria.PriceFrom = this._validationService.commaFormat(this.searchCriteria.PriceFrom);
      this.searchCriteria.PriceTo = this._validationService.commaFormat(this.searchCriteria.PriceTo);
      this.searchCriteria.NOIFrom = this._validationService.commaFormat(this.searchCriteria.NOIFrom);
      this.searchCriteria.NOITo = this._validationService.commaFormat(this.searchCriteria.NOITo);
      this.searchCriteria.Address = this.searchCriteria.Address != null && this.searchCriteria.Address != '' ? null : this.searchCriteria.Address;
      if (this.searchCriteria.IsRentAmount) {
        this.searchCriteria.RentFrom = this._validationService.commaFormat(this.searchCriteria.RentFrom);
        this.searchCriteria.RentTo = this._validationService.commaFormat(this.searchCriteria.RentTo);
      }
    }
    this.searchCriteria.PortfolioSaleOnly = false;
    this.user = this.authService.user != null ? this.authService.user : "";
    if (this.user != '') {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        this.canShowsavedSearch = true;
      }
    }

    this._commonService.getTypeList().subscribe(response => {
      this.inputAssetTypes = response.map(o => {
        return { id: o.Id, itemName: o.Type, subCategory: [], checked: (this.searchCriteria?.AssetTypes.length > 0 && this.searchCriteria?.AssetTypes.findIndex(f => f == o.Id) > -1 ? true : false) };
      });
      this.originalAssetTypes = this.inputAssetTypes;
      this.bindSubCategoroes(this.inputAssetTypes);
      this.buildTags(null, 3);
    });

    this._commonService.getLookupsByTypeId(LookUp.Rating).subscribe(response => {
      if (response != null && response.length > 0) {
        response = response.filter(x => x.IsActive == true);
        this.inputRatings = response.map(o => { return { id: o.Id, name: o.Description }; });
        this.buildTags(null, 4);
      }
    });

    this._propertyListingService.getTerms().subscribe(response => {
      if (response != null && response.length > 0) {
        this.inputTerms = response.map(o => { return { id: o.Id, name: o.Term }; });
      }
    });

    this.propertyStatusCalled = true;

    if (this.authService.user == null || this.authService.user == undefined) {
      this.bindPropertyStatus();
    }

    this._commonService.getStateList().subscribe(response => {
      if (response != null && response.length > 0) {
        this.inputStates = response.map(o => { return { id: o.Id, name: o.StateName } });
        this.buildTags(null, 9);
        this.dropdownStateClose(null);
      }
    });

    this._commonService.getLookupsByTypeId(LookUp.LeaseStructure).subscribe(response => {
      if (response != null && response.length > 0) {
        response = response.filter(x => x.IsActive == true);
        this.inputLeaseStructure = response.map(o => { return { id: o.Id, name: o.Description }; });
        this.buildTags(null, 10);
      }
    });

    // Loads the Property Characteristic
    this._commonService.getLookupsByTypeId(38).subscribe(response => {
      this.characteristicList = response.map(o => {
        return {
          id: o["Id"], name: o["Description"]
        };
      });
      this.buildTags(null, 19);
    });

    this._commonService.getLookupsByTypeId(LookUp.OwnershipType).subscribe(response => {
      if (response != null && response.length > 0) {
        this.inputOwnershipStructure = response.map(o => { return { id: o.Id, name: o.Description } });
        this.buildTags(null, 14);
      }
    });

    if (this._propertyListingService.criteria != undefined && this._propertyListingService.criteria.TakeCount != undefined) {
      for (let i = 0; i <= 21; i++) {
        this.buildTags(null, i);
      }
    }

    this.authService.isLoggedIn.subscribe(response => {
      this.isUserLoggedIn = response;
      if (response) {
        //this.fillPrevSearchCriteria = this._propertyListingService.fillPrevSearchCriteria;
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        this.user = loggedUserDetails;
        if (this.user != '') {
          if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
            this.canShowsavedSearch = true;
          }

          this.bindPropertyStatus();
          //if ((this._propertyListingService.fromHome && !this.isPageLoad) || (this.fillPrevSearchCriteria)) { // this function will execute only if the user is logged in
          ////if ((this._propertyListingService.fromHome && !this.isPageLoad)) { // this function will execute only if the user is logged in
          ////
          ////this.searchCriteria = this._propertyListingService.criteria;
          ////this.searchCriteria.LoggedInUserId = this.user.Id;
          ////this.onPropertySearch();
          ////}
        }
      }
      this.isPageLoad = false;
    });
    this.loadItems();
    this.loadTenants();
    this.loadAddressItems();
    if (this.isFav || this.isDisliked) {
      this.canShowsavedSearch = false;
    }
  }

  bindPropertyStatus() {
    this._commonService.getLookupsByTypeId(LookUp.PropertyStatus).subscribe(response => {
      if (response != null && response.length > 0) {
        response = response.filter(x => x.IsActive == true);
        this.inputPropertyStatus = response.map(o => { return { id: o.Id, name: o.Description }; }).filter(x => x.id != 355 && x.id != 349 && x.id != 350);
        if (!this.authService.Admin() && !this.authService.SuperAdmin()) {
          this.inputPropertyStatus = this.inputPropertyStatus.filter(i => i.id != 359);
        }
        if (this.authService._user == null) {
          this.inputPropertyStatus = this.inputPropertyStatus.filter(i => i.id != 356);
        }
        this.buildTags(null, 12);
        //this._validationService.removeNotAvailableStatusFromPropertyStatus(this.inputPropertyStatus);
      }
    });

  }

  private loadAddressItems() {
    this.AddressService$ = this.AddressServiceInput$.pipe(
      distinctUntilChanged(),
      debounceTime(400),
      tap(() => this.loading = true),
      switchMap(term => this.getAddressItemsList(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getAddressItemsList(term: any = null): Observable<any[]> {

    return this.propertyManagement.GetAddressByAutocompleteForAdvanceFilter(term, (this.user ? this.user.Id : 0), 0);
  }

  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      debounceTime(400),
      tap(() => this.loading = true),
      switchMap(term => this.getItems(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getItems(term: any = null): Observable<any[]> {
    var type = this._commonService.getSelectedComponent(this.router.url);
    return this.propertyManagement.GetTenantByAutocompleteForAdvanceFilter(term, (this.user ? this.user.Id : 0), type);

  }
  clearAutocompleteList() {
    this.loadItems();
  }

  private loadTenants() {
    this.dataTenantService$ = this.dataTenantServiceInput$.pipe(
      distinctUntilChanged(),
      debounceTime(400),
      tap(() => this.loading = true),
      switchMap(term => this.getTenantList(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getTenantList(term: any = null): Observable<any[]> {
    var type = this._commonService.getSelectedComponent(this.router.url);
    return this.propertyManagement.GetTenantByAutocompleteForAdvanceFilter(term, (this.user ? this.user.Id : 0), type);
    //    return this.propertyManagement.getTenantList(term);

  }


  onPropertySearch() {

    this.searchInformationValidation();
    if (this.IsValid == true) {
      this.searchCriteria.IsTileList = true;
      this.searchCriteria.Brokerages = null;
      this.searchCriteria.IsSearchButtonClicked = true;
      this.searchCriteria.LoggedInUserId = this.user.Id;
      this.searchCriteria.FilterTagCount = this.filterTags != null && this.filterTags?.length > 0 ? this.filterTags.length: 0;
      //localStorage.setItem("searchCriteria_buy", JSON.stringify(this.searchCriteria));
      this.propertySearchCriteria.emit(this.searchCriteria);
    }
    else {
      return false;

    }

  }

  onRentEscalationChange(val: boolean) {
    //this.rentEscalationLabel = val ? "$" : "%";
    this.searchCriteria.IsRentAmount = val;
    this.buildTags(null, 15);
  }
  onStateChange(e) {

    if (e.target.className.indexOf('caret') > -1 && this.searchCriteria.StateId != null) {
      this.searchCriteria.StateId = null;
    }
  }

  defaultSearchCriteriaValues() {
    this.selectedAssetTypes = [];
    this.searchCriteria.SkipCount = 0;
    this.searchCriteria.TakeCount = 21;
    this.searchCriteria.Address = null;
    this.searchCriteria.AssetTypes = [];
    this.searchCriteria.PriceFrom = null;
    this.searchCriteria.PriceTo = null;
    this.searchCriteria.Tenants = [];
    this.searchCriteria.TenantsNames = [];
    this.searchCriteria.Ratings = [];
    this.searchCriteria.Terms = [];

    this.searchCriteria.SortValue = "PHL";

    this.searchCriteria.NOIFrom = null;
    this.searchCriteria.NOITo = null;
    this.searchCriteria.BuildingSizeFrom = null;
    this.searchCriteria.BuildingSizeTo = null;
    this.searchCriteria.YearBuiltFrom = null;
    this.searchCriteria.YearBuiltTo = null;
    this.searchCriteria.StateId = null;
    this.searchCriteria.LeaseStructures = null;
    this.searchCriteria.CapRateFrom = null;
    this.searchCriteria.CapRateTo = null;
    this.searchCriteria.PropertyStatus = null;
    this.searchCriteria.SubCategories = null;
    this.searchCriteria.Brokerages = null;
    this.searchCriteria.States = null;
    this.searchCriteria.IsRentAmount = false;
    this.searchCriteria.RentFrom = null;
    this.searchCriteria.RentTo = null;
    this.searchCriteria.OwnershipTypes = null;
    this.searchCriteria.IsExcludeSoldListing = false;
    this.searchCriteria.IsOnlySoldListing = false;
    this.searchCriteria.IsExcludeContractListing = false;
    this.searchCriteria.IsOnlyFeaturedListing = false;
    this.searchCriteria.IsFavorite = false;
    this.searchCriteria.LoggedInUserId = this.user != null ? this.user.Id : 0;
    this.searchCriteria.IsDisliked = false;
    this.searchCriteria.IsTileList = true;
    this.searchCriteria.IsPortfolio = false;
    this.searchCriteria.CharacteristicsId = null;

    this.searchCriteria.MinTerm = null;
    this.searchCriteria.MaxTerm = null;

    this.rentValidation = "";
    this.buildsizeValidation = "";
    this.yearbuiltValidation = "";
    this.caprateValidation = "";
    this.rentescalationValidation = "";
    this.searchCriteria.AddressType = 0;
    this.searchCriteria.AddressTypeId = 0;
    this.searchCriteria.PropertySequenceId = null;
    this.searchCriteria.TenantAddress = [];
    this.searchCriteria.CityId = null;
    this.searchCriteria.AdvanceFilterStates = [];
    this.searchCriteria.TenantsNames = [];
    this.searchCriteria.TenantInput = '';
    this.searchCriteria.TenantFullAddress = null;
    this.searchCriteria.TenantFullAdressInput = '';
    this.searchCriteria.TenantAddressInput = '';
    this.searchCriteria.AdvanceFilterStateId = null;
    this.searchCriteria.IsSavedSearch = false;
    this.searchCriteria.IsReset = false;
    this.uncheckAll();
  }

  clearAllSelections() {
    this.matSelects.toArray().forEach(select => {
      select.value = null;  // Clear the value of each MatSelect
    });
  }

  onResetAdvanceFilterClick() {
    var input = $(".search-field-input");
    input.each(function (item) {
      $(input[item]).val("");
    });

    this.clearAllSelections();
    this.searchCriteria.StateId = null;
    this.searchCriteria.LeaseStructures = null;
    this.searchCriteria.PropertyStatus = null;
    this.searchCriteria.SubCategories = null;
    this.searchCriteria.Brokerages = null;
    this.searchCriteria.AdvanceFilterStates = null;
    this.searchCriteria.OwnershipTypes = null;
    this.searchCriteria.IsExcludeSoldListing = false;
    this.searchCriteria.IsOnlySoldListing = false;
    this.searchCriteria.IsExcludeContractListing = false;
    this.searchCriteria.IsOnlyFeaturedListing = false;
    this.searchCriteria.IsSearchButtonClicked = false;
    this.searchCriteria.NOIFrom = null;
    this.searchCriteria.NOITo = null;
    this.searchCriteria.BuildingSizeFrom = null;
    this.searchCriteria.BuildingSizeTo = null;
    this.searchCriteria.YearBuiltFrom = null;
    this.searchCriteria.YearBuiltTo = null;
    this.searchCriteria.RentFrom = null;
    this.searchCriteria.RentTo = null;
    this.searchCriteria.CharacteristicsId = null;
    this.searchCriteria.SortValue = "PHL";
    this.searchCriteria.PortfolioSaleOnly = false;
    this.searchCriteria.IsPortfolio = false;
    this.searchCriteria.PropertySequenceId = null;
    this.searchCriteria.TenantInput = '';
    this.searchCriteria.AdvanceFilterStateId = null;
    this.searchCriteria.CityId = null;
    this.searchCriteria.TenantFullAddress = null;
    this.searchCriteria.TenantFullAdressInput = '';
    this.searchCriteria.Ratings = [];
    this.tenantFilterTags = [];
    this.rentValidation = "";
    this.buildsizeValidation = "";
    this.yearbuiltValidation = "";
    this.rentescalationValidation = "";
    this.searchCriteria.Address = '';
    this.searchCriteria.AddressType = null;
    this.searchCriteria.TenantsNames = [];
    this.searchCriteria.TenantAddress = [];
    for (let i = 0; i < 22; i++) {
      this.buildTags(null, i);
    }
    this.originalSearchCriteria = structuredClone(this.searchCriteria);
    this.onPropertySearch();
  }

  onResetFilterClick() {
    var input = $(".search-field-input");
    input.each(function (item) {
      $(input[item]).val("");
    });

    // if (this.dropdownTenants != undefined && this.dropdownTenants != null) {
    //   this.dropdownTenants.clearSearch();
    // }
    this.clearAllSelections();
    this.searchCriteria.StateId = null;
    this.searchCriteria.LeaseStructures = null;
    this.searchCriteria.PropertyStatus = null;
    this.searchCriteria.SubCategories = null;
    this.searchCriteria.Brokerages = null;
    this.searchCriteria.States = null;
    this.searchCriteria.OwnershipTypes = null;
    this.searchCriteria.IsExcludeSoldListing = false;
    this.searchCriteria.IsOnlySoldListing = false;
    this.searchCriteria.IsExcludeContractListing = false;
    this.searchCriteria.IsOnlyFeaturedListing = false;
    this.searchCriteria.IsSearchButtonClicked = false;
    this.searchCriteria.CapRateFrom = null;
    this.searchCriteria.CapRateTo = null;
    this.searchCriteria.NOIFrom = null;
    this.searchCriteria.NOITo = null;
    this.searchCriteria.BuildingSizeFrom = null;
    this.searchCriteria.BuildingSizeTo = null;
    this.searchCriteria.YearBuiltFrom = null;
    this.searchCriteria.YearBuiltTo = null;
    this.searchCriteria.RentFrom = null;
    this.searchCriteria.RentTo = null;
    this.searchCriteria.CharacteristicsId = null;
    this.searchCriteria.SortValue = "PHL";
    this.searchCriteria.PortfolioSaleOnly = false;
    this.searchCriteria.IsPortfolio = false;
    this.searchCriteria.PropertySequenceId = null;

    for (let i = 6; i < 22; i++) {
      let index = this.filterTags.findIndex(x => x.Id == i);
      if (index > -1) {
        this.filterTags.splice(index, 1);
      }
    }
    this.onPropertySearch();
  }

  onResetClick() {
    this.filterTags = [];
    var input = $(".search-field-input");
    input.each(function (item) {
      $(input[item]).val("");
    });
    // if (this.dropdownTenants != undefined && this.dropdownTenants != null) {
    //   this.dropdownTenants.clearSearch();
    // }
    this.searchCriteria.IsSearchButtonClicked = false;
    this.Shared.resetClicked(true);
    localStorage.removeItem("LatFrom");
    localStorage.removeItem("LatTo");
    localStorage.removeItem("LongTo");
    localStorage.removeItem("LongFrom");
    localStorage.removeItem("LatFromDislike");
    localStorage.removeItem("LatToDislike");
    localStorage.removeItem("LongToDislike");
    localStorage.removeItem("LongFromDislike");
    localStorage.removeItem("LatFromFavorite");
    localStorage.removeItem("LatToFavorite");
    localStorage.removeItem("LongToFavorite");
    localStorage.removeItem("LongFromFavorite");
    localStorage.removeItem("searchCriteria_buy");
    this.defaultSearchCriteriaValues();
    this.searchInformationValidation();
    this.searchCriteria.IsReset = true;
    this._propertyListingService.criteria = this.searchCriteria;
    if (this.IsValid == true) {
      this.searchCriteria.IsTileList = true;

      this.searchCriteria.LoggedInUserId = this.user.Id;
      this.searchCriteria.FilterTagCount = this.filterTags != null && this.filterTags?.length > 0 ? this.filterTags.length : 0;
      this.propertySearchCriteria.emit(this.searchCriteria);
    }
    else {
      return false;

    }
    if (this.search != undefined) {
      this.router.navigateByUrl('/propertylisting?request=buy');
    }
    }

  saveSearch() {
    if (this.isUserLoggedIn) {

      if (this.filterTags.length <= 0) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Nothing  Selected', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      else {
        if (this._validationService.IsinValid(this.saveSearchInputModel.SearchName)) {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Please enter search name', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
        else {
          this.saveSearchInputModel.PropertySearchCriteria = this.searchCriteria;
          let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
          this.saveSearchInputModel.UserId = loggedUserDetails.Id;
          this._propertyListingService.saveSearch(this.saveSearchInputModel).subscribe(response => {
            this.saveSearchResponse = response;
            if (this.saveSearchResponse.Success) {
              this.saveSearchEmitter.emit();
              this.saveSearchInputModel.SearchName = null;
              this._toastService.addToast({ title: 'Success', msg: 'Search saved successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
              this._propertyListingService.UpdateSaveSearch(true); //this code will trigger save seach binding function in the header component to re bind the save search
              this.modalRef.hide();
              this.loadSaveSearch.emit();
            }
            else {
              this._toastService.addToast({ title: 'Error Occurred', msg: this.saveSearchResponse.ReturnMsg, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
          });
        }
      }
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to save your searches", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }

  }

  modalRef: BsModalRef;
  saveSearchCriteriaList = [];
  openModal(template: TemplateRef<any>, classes: any) {
    this.authService.isLoggedIn.subscribe(response => {
      this.isUserLoggedIn = response
    });

    if (this.isUserLoggedIn) {
      this.saveSearchInputModel.SearchName = null;
      this.saveSearchCriteriaList = [];
      this.modalRef = this.modalService.show(template, { class: classes });
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to save your searches", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }

  IsNull(val) {
    if (val == null || val == "0" || val == undefined) {
      return '';
    }
    return val;
  }

  IsChecked(val) {

    if (val == false || val == undefined) {
      return '';
    }
    return 1;
  }
  validateDecimals() {
    this.searchCriteria.BuildingSizeFrom = this._validationService.DecimalOnly(this.searchCriteria.BuildingSizeFrom);
    this.searchCriteria.BuildingSizeTo = this._validationService.DecimalOnly(this.searchCriteria.BuildingSizeTo);
    this.searchCriteria.CapRateFrom = this._validationService.DecimalOnly(this.searchCriteria.CapRateFrom);
    this.searchCriteria.CapRateTo = this._validationService.DecimalOnly(this.searchCriteria.CapRateTo);
  }

  validateFilters() {
    if (this.IsValid == false) {
      this.searchInformationValidation();
    }
  }

  validateAdvanceFilter() {
    this.validateDecimals();
    let IsValidFilter = true;
    if ((this._validationService.IsNull(this.searchCriteria.NOIFrom) != '' && this._validationService.IsNull(this.searchCriteria.NOITo) != '') && (Number(this.searchCriteria.NOIFrom) > Number(this.searchCriteria.NOITo))) {
      this.rentInvalid = true;
      IsValidFilter = false;
      this.rentValidation = 'NOI/Rent To should be greater that NOI/Rent From';
    }
    else {
      this.rentInvalid = false;
      this.rentValidation = "";
    }
    if ((this._validationService.IsNull(this.searchCriteria.BuildingSizeFrom) != '' && this._validationService.IsNull(this.searchCriteria.BuildingSizeTo) != '') && (Number(this.searchCriteria.BuildingSizeFrom) > Number(this.searchCriteria.BuildingSizeTo))) {
      this.buildsizeInvalid = true;
      IsValidFilter = false;
      this.buildsizeValidation = 'Building Size To should be greater than Building Size From';
    }
    else {
      this.buildsizeInvalid = false;
      this.buildsizeValidation = "";
    }


    if ((this._validationService.IsNull(this.searchCriteria.YearBuiltFrom) != '' && this._validationService.IsNull(this.searchCriteria.YearBuiltTo) != '') && (Number(this.searchCriteria.YearBuiltFrom) > Number(this.searchCriteria.YearBuiltTo))) {
      this.yearbuiltInvalid = true;
      IsValidFilter = false;
      this.yearbuiltValidation = 'Year Built To should be greater than Year Built From';
    }
    else {
      this.yearbuiltInvalid = false;
      this.yearbuiltValidation = "";
    }
    if ((this._validationService.IsNull(this.searchCriteria.RentFrom) != '' && this._validationService.IsNull(this.searchCriteria.RentTo) != '') && (Number(this.searchCriteria.RentFrom) > Number(this.searchCriteria.RentTo))) {
      this.rentescalationInavlid = true;
      IsValidFilter = false;
      this.rentescalationValidation = 'Rent To should be greater than Rent From';
    }
    else {
      this.rentescalationInavlid = false;
      this.rentescalationValidation = "";
    }
    return IsValidFilter;
  }

  searchInformationValidation() {
    this.validateDecimals();
    this.IsValid = true;
    if ((this._validationService.IsNull(this.searchCriteria.NOIFrom) != '' && this._validationService.IsNull(this.searchCriteria.NOITo) != '') && (Number(this.searchCriteria.NOIFrom) > Number(this.searchCriteria.NOITo))) {
      this.rentInvalid = true;
      this.IsValid = false;
      this.rentValidation = 'NOI/Rent To should be greater that NOI/Rent From';
      this._toastService.addToast({
        title: 'Error Occurred', msg: 'NOI/Rent To should be greater than NOI/Rent From', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
      })
    }
    else {
      this.rentInvalid = false;
      this.rentValidation = "";
    }
    if ((this._validationService.IsNull(this.searchCriteria.BuildingSizeFrom) != '' && this._validationService.IsNull(this.searchCriteria.BuildingSizeTo) != '') && (Number(this.searchCriteria.BuildingSizeFrom) > Number(this.searchCriteria.BuildingSizeTo))) {
      this.buildsizeInvalid = true;
      this.IsValid = false;
      this.buildsizeValidation = 'Building Size To should be greater than Building Size From';
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Building Size To should be greater than Building Size From', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      this.buildsizeInvalid = false;
      this.buildsizeValidation = "";
    }


    if ((this._validationService.IsNull(this.searchCriteria.YearBuiltFrom) != '' && this._validationService.IsNull(this.searchCriteria.YearBuiltTo) != '') && (Number(this.searchCriteria.YearBuiltFrom) > Number(this.searchCriteria.YearBuiltTo))) {
      this.yearbuiltInvalid = true;
      this.IsValid = false;
      this.yearbuiltValidation = 'Year Built To should be greater than Year Built From';
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Year Built To should be greater than Year Built From', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      this.yearbuiltInvalid = false;
      this.yearbuiltValidation = "";
    }

    if ((this._validationService.IsNull(this.searchCriteria.CapRateFrom) != '' && this._validationService.IsNull(this.searchCriteria.CapRateTo) != '') && (Number(this.searchCriteria.CapRateFrom) > Number(this.searchCriteria.CapRateTo))) {
      this.caprateInvalid = true;
      this.IsValid = false;
      this.caprateValidation = 'Cap Rate To should be greater than Cap rate From';
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Cap Rate To should be greater than Cap rate From', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      this.caprateInvalid = false;
      this.caprateValidation = "";
    }

    if ((this._validationService.IsNull(this.searchCriteria.RentFrom) != '' && this._validationService.IsNull(this.searchCriteria.RentTo) != '') && (Number(this.searchCriteria.RentFrom) > Number(this.searchCriteria.RentTo))) {
      this.rentescalationInavlid = true;
      this.IsValid = false;
      this.rentescalationValidation = 'Rent To should be greater than Rent From';
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Rent To should be greater than Rent From', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      this.rentescalationInavlid = false;
      this.rentescalationValidation = "";
    }

    if ((this._validationService.IsNull(this.searchCriteria.PriceFrom) != '' && this._validationService.IsNull(this.searchCriteria.PriceTo) != '') && (Number(this.searchCriteria.PriceFrom) > Number(this.searchCriteria.PriceTo))) {
      this.priceInValid = true;
      this.IsValid = false;
      this.priceValidation = 'Price To should be greater than Price From';
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Price To should be greater than Price From', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      this.priceInValid = false;
      this.priceValidation = "";
    }
  }

  dropdownStateClose(e) {
    if (this.searchCriteria.States) {
      let values = this.inputStates.map(o => { return { id: o.id, name: o.name, selected: this.searchCriteria.States.includes(o.id) ? true : false } });
      this.inputStates = values.sort((a, b) => a.selected > b.selected ? 1 : -1).sort((a, b) => a.selected ? -1 : (a.name > b.name) ? 1 : -1)
    }
  }

  filterTags: IFilterTag[] = [];
  tenantFilterTags: IFilterTag[] = [];
  buildTags(event, type: number, currentValue: any = null) {
    this.removeTag(type, 0);
    if (type === 1) {
      if (this.searchCriteria.TenantAddress != null && this.searchCriteria.TenantAddress != undefined && this.searchCriteria.TenantAddress.length > 0) {
        let result = "";
        this.searchCriteria.TenantAddress.forEach(item => {
          if (item.AddressType == 1) {
            result += item.Address + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Tenant : " + result
        });
      }

    }
    else if (type === 2) {
      //Price
      let price = '';
      if (this.IsNull(this.searchCriteria.PriceFrom)) {
        if (price === '') {
          price = "Price : ";
        }
        price += "$ " + this._validationService.commaFormat(this.searchCriteria.PriceFrom);
      }
      if (this.IsNull(this.searchCriteria.PriceTo)) {
        if (price === '') {
          price = "Price : $ 0 - ";
        }
        else {
          price += " - ";
        }
        price += "$ " + this._validationService.commaFormat(this.searchCriteria.PriceTo);
      }

      if (!this._validationService.IsinValid(price)) {
        this.filterTags.push({
          Id: type,
          Value: price
        });
      }
    }
    else if (type === 3) {   //Type
      if (this.searchCriteria.AssetTypes && this.searchCriteria.AssetTypes?.length > 0) {
        let result = "";

        this.searchCriteria.AssetTypes.forEach(item => {
          if (this.inputAssetTypes !== undefined && this.inputAssetTypes.length > 0) {

            result += this.inputAssetTypes.find(x => x.id === item)?.itemName + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Property Type : " + result
        });
      }
    }
    else if (type === 4) {
      //Rating
      if (this.searchCriteria.Ratings && this.searchCriteria.Ratings.length > 0) {
        let result = "";
        this.searchCriteria.Ratings.forEach(item => {
          if (this.inputRatings !== undefined) {
            result += this.inputRatings.find(x => x.id === item)?.name + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Rating : " + result
        });
      }
    }
    else if (type === 5) {
      //Years
      let term = '';
      if (this.IsNull(this.searchCriteria.MinTerm)) {
        if (term === '') {
          term = "Term : ";
        }
        term += this._validationService.commaFormat(this.searchCriteria.MinTerm);
      }
      if (this.IsNull(this.searchCriteria.MaxTerm)) {
        if (term === '') {
          term = "Term : 0 - ";
        }
        else {
          term += " - ";
        }
        term += this._validationService.commaFormat(this.searchCriteria.MaxTerm);
      }
      if (!this._validationService.IsinValid(term)) {
        term = term + " Years";
        this.filterTags.push({
          Id: type,
          Value: term
        });
      }
    }
    else if (type === 6) {
      let noi = '';
      if (this.IsNull(this.searchCriteria.NOIFrom)) {
        if (noi === '') {
          noi = "NOI/Rent : ";
        }
        noi += "$ " + this._validationService.commaFormat(this.searchCriteria.NOIFrom);
      }
      if (this.IsNull(this.searchCriteria.NOITo)) {
        if (noi === '') {
          noi = "NOI/Rent : $ 0 - ";
        }
        else {
          noi += " - ";
        }
        noi += "$ " + this._validationService.commaFormat(this.searchCriteria.NOITo);
      }
      if (!this._validationService.IsinValid(noi)) {
        this.filterTags.push({
          Id: type,
          Value: noi
        });
      }
    }
    else if (type === 7) {

      //Building Siz
      let BuildingSize = '';
      if (this.IsNull(this.searchCriteria.BuildingSizeFrom)) {
        if (BuildingSize === '') {
          BuildingSize = "Building Size : ";
        }
        BuildingSize += this._validationService.commaFormat(this.searchCriteria.BuildingSizeFrom);
      }
      if (this.IsNull(this.searchCriteria.BuildingSizeTo)) {
        if (BuildingSize === '') {
          BuildingSize = "Building Size : 0 - ";
        }
        else {
          BuildingSize += " - ";
        }
        BuildingSize += this._validationService.commaFormat(this.searchCriteria.BuildingSizeTo);
      }
      if (!this._validationService.IsinValid(BuildingSize)) {
        BuildingSize = BuildingSize + " SF";
        this.filterTags.push({
          Id: type,
          Value: BuildingSize
        });
      }

    }
    else if (type === 8) {
      //Year Built
      let YearBuilt = '';
      if (this.IsNull(this.searchCriteria.YearBuiltFrom)) {
        if (YearBuilt === '') {
          YearBuilt = "Year Built : ";
        }
        YearBuilt += (this.searchCriteria.YearBuiltFrom);
      }
      if (this.IsNull(this.searchCriteria.YearBuiltTo)) {
        if (YearBuilt === '') {
          YearBuilt = "Year Built : 0 - ";
        }
        else {
          YearBuilt += " - ";
        }
        YearBuilt += this.searchCriteria.YearBuiltTo;
      }
      if (!this._validationService.IsinValid(YearBuilt)) {
        this.filterTags.push({
          Id: type,
          Value: YearBuilt
        });
      }
    }
    else if (type === 9) {
      //state
      if (this.searchCriteria.States !== null && this.searchCriteria.States !== undefined && this.searchCriteria.States.length > 0) {
        if (this.searchCriteria.States != null) {
          let result = "";
          this.searchCriteria.States.forEach(item => {
            if (this.inputStates !== undefined) {
              result += this.inputStates.find(x => x.id === item)?.name + ", ";
            }
          });
          result = this._validationService.removeLastCharacterFromString(result);
          this.filterTags.push({
            Id: type,
            Value: "State : " + result
          });
        }
      }
    }
    else if (type === 10) {

      //Lease Structure
      if (this.searchCriteria.LeaseStructures != null && this.searchCriteria.LeaseStructures.length > 0) {
        let result = "";
        this.searchCriteria.LeaseStructures.forEach(item => {
          if (this.inputLeaseStructure !== undefined) {
            result += this.inputLeaseStructure.find(x => x.id === item)?.name + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Lease Structure : " + result
        });
      }
    }
    else if (type === 11) {
      //Cap Rate
      let CapRate = '';
      if (this.IsNull(this.searchCriteria.CapRateFrom)) {
        if (CapRate === '') {
          CapRate = "Cap Rate : ";
        }
        CapRate += this._validationService.commaFormat(this.searchCriteria.CapRateFrom) + "%";
      }
      if (this.IsNull(this.searchCriteria.CapRateTo)) {
        if (CapRate === '') {
          CapRate = "Cap Rate : 0% - ";
        }
        else {
          CapRate += " - ";
        }
        CapRate += this._validationService.commaFormat(this.searchCriteria.CapRateTo) + "%";
      }

      if (!this._validationService.IsinValid(CapRate)) {
        this.filterTags.push({
          Id: type,
          Value: CapRate
        });
      }
    }
    else if (type === 12) {
      //Property Status
      if (this.searchCriteria.PropertyStatus != null && this.searchCriteria.PropertyStatus.length > 0) {
        let result = "";
        this.searchCriteria.PropertyStatus.forEach(item => {
          if (this.inputPropertyStatus !== undefined) {
            result += this.inputPropertyStatus.find(x => x.id === item)?.name + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Property Status : " + result
        });
      }
    }
    else if (type === 13) {
      //SubCategories
      if (this.searchCriteria.SubCategories != null && this.searchCriteria.SubCategories.length > 0) {
        let result = "";
        this.searchCriteria.SubCategories.forEach(item => {
          if (this.inputSubCategory !== undefined) {
            result += this.inputSubCategory.find(x => x.id === item).name + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Subcategory : " + result
        });
      }
    }
    else if (type === 14) {
      //Ownership Structure
      if (this.searchCriteria.OwnershipTypes != null && this.searchCriteria.OwnershipTypes.length > 0) {
        let result = "";
        this.searchCriteria.OwnershipTypes.forEach(item => {
          if (this.inputOwnershipStructure !== undefined) {
            result += this.inputOwnershipStructure.find(x => x.id === item)?.name + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Ownership Structure : " + result
        });
      }
    }
    else if (type === 15) {
      //Rent Escalation Amount
      if (this.searchCriteria.IsRentAmount) {

        let RentEscalationAmount = '';
        if (this.IsNull(this.searchCriteria.RentFrom)) {
          if (RentEscalationAmount === '') {
            RentEscalationAmount = "Rent Escalation Amount : ";
          }
          RentEscalationAmount += "$ " + this._validationService.commaFormat(this.searchCriteria.RentFrom);
        }
        if (this.IsNull(this.searchCriteria.RentTo)) {
          if (RentEscalationAmount === '') {
            RentEscalationAmount = "Rent Escalation Amount : $ 0 - ";
          }
          else {
            RentEscalationAmount += " - ";
          }
          RentEscalationAmount += "$ " + this._validationService.commaFormat(this.searchCriteria.RentTo);
        }
        if (!this._validationService.IsinValid(RentEscalationAmount)) {
          this.filterTags.push({
            Id: type,
            Value: RentEscalationAmount
          });
        }
      }
      else { //Rent Escalation Percentage
        let RentEscalationPercentage = '';
        if (this.IsNull(this.searchCriteria.RentFrom)) {
          if (RentEscalationPercentage === '') {
            RentEscalationPercentage = "Rent Escalation Percentage : ";
          }
          RentEscalationPercentage += this._validationService.commaFormat(this.searchCriteria.RentFrom) + "%";
        }
        if (this.IsNull(this.searchCriteria.RentTo)) {
          if (RentEscalationPercentage === '') {
            RentEscalationPercentage = "Rent Escalation Percentage : 0% - ";
          }
          else {
            RentEscalationPercentage += " - ";
          }
          RentEscalationPercentage += this._validationService.commaFormat(this.searchCriteria.RentTo) + "%";
        }

        if (!this._validationService.IsinValid(RentEscalationPercentage)) {
          this.filterTags.push({
            Id: type,
            Value: RentEscalationPercentage
          });
        }
      }
    }
    else if (type === 16) {
      //Exclude sold listings
      if (this.searchCriteria.IsExcludeSoldListing) {
        this.filterTags.push({
          Id: type,
          Value: "Exclude sold listings"
        });
      }
    }
    else if (type === 17) {
      //Exclude listings under contract
      if (this.searchCriteria.IsExcludeContractListing) {
        this.filterTags.push({
          Id: type,
          Value: "Exclude listings under contract"
        });
      }
    }
    else if (type === 19) {
      //Property Characteristics
      if (this.searchCriteria.CharacteristicsId != null && this.searchCriteria.CharacteristicsId.length > 0) {
        let result = "";
        this.searchCriteria.CharacteristicsId.forEach((item: any) => {
          if (this.characteristicList !== undefined) {
            result += this.characteristicList.find(x => x.id === item).name + ", ";
          }
        });
        result = this._validationService.removeLastCharacterFromString(result);
        this.filterTags.push({
          Id: type,
          Value: "Property Characteristics : " + result
        });
      }
    }
    else if (type === 20) {
      //Is Portfolio
      if (this.searchCriteria.IsPortfolio) {
        this.filterTags.push({
          Id: type,
          Value: "Show Only Portfolio"
        });
      }
    }
    else if (type === 21) {
      //Property Sequence Id
      if (this.searchCriteria.PropertySequenceId) {
        this.filterTags.push({
          Id: type,
          Value: "Property Id : " + this.searchCriteria.PropertySequenceId
        });
      }
    }
    else if (type === 22) {
      //Property Sequence Id
      if (this.searchCriteria.CityId) {
        if (this.citiesList.findIndex(f => f.Id == this.searchCriteria.CityId) > -1) {
          let currentCity = this.citiesList.find(f => f.Id == this.searchCriteria.CityId);
          this.filterTags.push({
            Id: type,
            Value: "City : " + currentCity.Name
          });
        }
      }
    }
    else if (type === 23) {
      //Property Sequence Id
      if (this.searchCriteria.Address) {
        this.filterTags.push({
          Id: type,
          Value: "Address : " + this.searchCriteria.Address
        });
      }
    }

  }

  removeTenantTag(tag) {

    if (tag) {
      let index = this.tenantFilterTags.findIndex(x => x.Value == tag.Value);
      if (index > -1) {
        let currentTenant = this.tenantFilterTags.find(x => x.Value == tag.Value);
        if (currentTenant != null && currentTenant != undefined) {
          if (this.searchCriteria?.TenantsNames.findIndex(f => f.Address == currentTenant.Value) > -1) {
            let currentIndex = this.searchCriteria?.TenantsNames.findIndex(f => f.Address == currentTenant.Value);
            if (currentIndex > -1) {
              this.searchCriteria?.TenantsNames.splice(index, 1);
            }
          }
        }
        this.tenantFilterTags.splice(index, 1);
      }
    }
  }

  removeTag(type: number, callFrom: number) {

    let index = this.filterTags.findIndex(x => x.Id == type);
    if (index > -1) {
      this.filterTags.splice(index, 1);
    }
    if (callFrom == 1) {

      if (type === 1) {
        this.tenantFilterTags = [];
        this.searchCriteria.PropertyId = null;
        if (this.searchCriteria.TenantAddress.findIndex(f => f.AddressType == 1) > -1) {
          this.searchCriteria.TenantAddress = this.searchCriteria.TenantAddress.filter(item => item.AddressType != 1);
        }
        if (this.searchCriteria.SortValue == this.sort.Rank) {
          this.searchCriteria.SortValue = this.sort.PriceHighLow;
        }
      }
      else if (type === 2) {
        //Price
        this.searchCriteria.PriceFrom = null;
        this.searchCriteria.PriceTo = null;
      }
      else if (type === 3) {
        //Type
        this.searchCriteria.AssetTypes = [];
        this.selectedAssetTypes = [];
        this.setassetTypetoFalse();
      }
      else if (type === 4) {
        //Rating
        this.searchCriteria.Ratings = [];
      }
      else if (type === 5) {
        //Years
        this.searchCriteria.MinTerm = null;
        this.searchCriteria.MaxTerm = null;
      }
      else if (type === 6) {
        // NOI
        this.searchCriteria.NOIFrom = null;
        this.searchCriteria.NOITo = null;
      }
      else if (type === 7) {
        //Building Siz
        this.searchCriteria.BuildingSizeFrom = null;
        this.searchCriteria.BuildingSizeTo = null;
      }
      else if (type === 8) {
        //Year Built
        this.searchCriteria.YearBuiltFrom = null;
        this.searchCriteria.YearBuiltTo = null;
        $("#txtYearBuiltFrom").val('');
        $("#txtYearBuiltTo").val('');
      }
      else if (type === 9) {
        //state
        this.searchCriteria.States = [];
        this.searchCriteria.AdvanceFilterStates = [];
      }
      else if (type === 10) {
        //Lease Structure
        this.searchCriteria.LeaseStructures = [];
      }
      else if (type === 11) {
        //Cap Rate
        this.searchCriteria.CapRateFrom = null;
        this.searchCriteria.CapRateTo = null;
      }
      else if (type === 12) {
        //Property Status
        this.searchCriteria.PropertyStatus = [];
      }
      else if (type === 13) {
        //SubCategories
        this.searchCriteria.SubCategories = [];
        this.setSubcategorytoFalse();
      }
      else if (type === 14) {
        //Ownership Structure
        this.searchCriteria.OwnershipTypes = [];
      }
      else if (type === 15) {
        //Rent Escalation Amount
        this.searchCriteria.RentFrom = null;
        this.searchCriteria.RentTo = null;
      }
      else if (type === 16) {
        //Exclude sold listings
        this.searchCriteria.IsExcludeSoldListing = false;
      }
      else if (type === 17) {
        //Exclude listings under contract
        this.searchCriteria.IsExcludeContractListing = false;
      }
      else if (type === 19) {
        //characteristics
        this.searchCriteria.CharacteristicsId = [];
      }
      else if (type === 20) {
        //characteristics
        this.searchCriteria.IsPortfolio = false;
      }
      else if (type === 21) {
        //characteristics
        this.searchCriteria.PropertySequenceId = null;
      }
      else if (type === 22) {
        this.searchCriteria.CityId = null;
      }
      else if (type === 23) {
        this.searchCriteria.TenantFullAddress = null;
        this.searchCriteria.TenantFullAdressInput = null;
        this.searchCriteria.Address = null;
        this.searchCriteria.AddressType = null;
        this.searchCriteria.AddressTypeId = null;
        this.searchCriteria.AddressTypeName = null;
      }
      this.onPropertySearch();

      if (!this._validationService.IsinValid(this.search) && this.filterTags.length == 0) {
        this.router.navigateByUrl('/propertylisting?request=buy');
      }
    }
  }
  onTenantSelect($event) {
    if ($event != null) {
      this.searchCriteria.TenantInput = '';
      this.dataTenantServiceInput$.next('');
      if (this.searchCriteria?.TenantsNames.findIndex(f => f.Address == $event.PropertyName) <= -1) {
        let address
          = {
          Address: $event.PropertyName,
          AddressTypeId: $event.Id,
          AddressType: 1,
          AddressTypeName: 'Tenant'
        };
        this.searchCriteria?.TenantsNames.push(address);
        // this.searchCriteria?.TenantAddress?.push(address);
        if (address.AddressType == 1) {
          this.tableState.push({
            TableName: 'DataTables_property_list_view',
            TableState: null,
            IsSortOrderChanged: true,
          });
          this.tableState.push({
            TableName: 'DataTables_property_list_view_Disliked',
            TableState: null,
            IsSortOrderChanged: true,
          });
          this.tableState.push({
            TableName: 'DataTables_property_list_view_Fav',
            TableState: null,
            IsSortOrderChanged: true,
          });
          this.tableState.push({
            TableName: 'DataTables_comp_listing',
            TableState: null,
            IsSortOrderChanged: true,
          });
          this.tableState.push({
            TableName: 'DataTables_archive_list_view',
            TableState: null,
            IsSortOrderChanged: true,
          });
          this.tableState.push({
            TableName: 'DataTables_my_property_list_view',
            TableState: null,
            IsSortOrderChanged: true,
          });
          localStorage.setItem('TableStates', JSON.stringify(this.tableState));
        }
        else if (this.searchCriteria.SortValue == this.sort.Rank) {
          this.searchCriteria.SortValue = this.sort.PriceHighLow;
        }

        if (!this._validationService.IsinValid(address.Address) && address.AddressTypeName != null && address.AddressTypeName != undefined) {

          this.tenantFilterTags.push(
            {
              Id: $event.Id,
              Value: address.Address
            });
        }
      }
    }
  }

  onAddressInputChange(value: any) {
    if (!value || (typeof value === 'string' && value.trim() === '')) {
      // Input cleared — reset logic here
      this.clearAddressSelection();
    }
  }
  clearAddressSelection() {
    // Clear dependent fields, reset API call, etc.
    this.searchCriteria.TenantFullAddress = null;
    if (this.searchCriteria.AdvanceFilterStateId != null && this.searchCriteria.AdvanceFilterStateId != undefined) {
      this.searchCriteria.AdvanceFilterStates = this.searchCriteria.AdvanceFilterStates.filter(f => f != this.searchCriteria.AdvanceFilterStateId);
      this.searchCriteria.AdvanceFilterStateId = null;
    }
    this.searchCriteria.CityId = null;
  }

  onAddressSelect($event) {
    if ($event != null) {
      let address
        = {
        Address: $event.PropertyName,
        AddressTypeId: $event.Id,
        AddressType: $event.AddressTypeID,
        AddressTypeName: $event.Type
      };

      this.searchCriteria.TenantFullAddress = address;
      if ($event.StateId != null) {
        if (!Array.isArray(this.searchCriteria.AdvanceFilterStates)) {
          this.searchCriteria.AdvanceFilterStates = [];
        }
        if (this.searchCriteria.AdvanceFilterStateId != null && this.searchCriteria.AdvanceFilterStateId != undefined && this.searchCriteria.AdvanceFilterStateId != $event.StateId) {
          this.searchCriteria.AdvanceFilterStates = this.searchCriteria.AdvanceFilterStates.filter(f => f != this.searchCriteria.AdvanceFilterStateId);
          this.searchCriteria.AdvanceFilterStateId = null;
        }
        this.searchCriteria.AdvanceFilterStateId = $event.StateId;
        if (this.searchCriteria.AdvanceFilterStates.findIndex(x => x == $event.StateId) <= -1) {
          let currentdata = this.searchCriteria.AdvanceFilterStates;
          currentdata.push($event.StateId);

          this.searchCriteria.AdvanceFilterStates = [];
          this.searchCriteria.AdvanceFilterStates = this.inputStates.filter(state => currentdata.includes(state.id)).map(m => m.id);
        }
      }
      if ($event.CityId != null) {
        this.bindCity(this.searchCriteria.AdvanceFilterStates);
        this.searchCriteria.CityId = $event.CityId;
      }
    }
  }

  onPropertySelect($event) {
    if ($event != null) {
      if (this.searchCriteria?.TenantAddress.findIndex(f => f.Address == $event.PropertyName) <= -1) {
        this.searchCriteria.TenantAddressInput = '';
        let address
          = {
          Address: $event.PropertyName,
          AddressTypeId: $event.Id,
          AddressType: $event.AddressTypeID,
          AddressTypeName: $event.Type
        };
        if (!Array.isArray(this.searchCriteria.TenantAddress)) {
          this.searchCriteria.TenantAddress = [];
        }
        this.searchCriteria?.TenantAddress?.push(address);
        this.dataServiceInput$.next('');
        if (this.searchCriteria.AddressType == 1) {
          if (!Array.isArray(this.searchCriteria.TenantsNames)) {
            this.searchCriteria.TenantsNames = [];
          }
          this.searchCriteria?.TenantsNames.push(address);
          this.searchCriteria.SortValue = this.sort.Rank;
          this.tableState.push({ TableName: "DataTables_property_list_view", TableState: null, IsSortOrderChanged: true });
          this.tableState.push({ TableName: "DataTables_property_list_view_Disliked", TableState: null, IsSortOrderChanged: true });
          this.tableState.push({ TableName: "DataTables_property_list_view_Fav", TableState: null, IsSortOrderChanged: true });
          this.tableState.push({ TableName: "DataTables_comp_listing", TableState: null, IsSortOrderChanged: true });
          this.tableState.push({ TableName: "DataTables_archive_list_view", TableState: null, IsSortOrderChanged: true });
          this.tableState.push({ TableName: "DataTables_my_property_list_view", TableState: null, IsSortOrderChanged: true });
          localStorage.setItem('TableStates', JSON.stringify(this.tableState));
        }
        else if (this.searchCriteria.SortValue == this.sort.Rank) {
          this.searchCriteria.SortValue = this.sort.PriceHighLow;
        }
        this.buildTags($event, 1, address);
        this.onPropertySearch();
      }
    }
    else {
      this.searchCriteria.TenantAddressInput = '';
      this.searchCriteria.TenantAddress = [];
      this.searchCriteria.SortValue = "PHL";
      this.buildTags(null, 1);
    }
  }

  onKeydown(event) {

    if (event.key === "Enter" && this.searchCriteria.AddressType == 0) {
      this.onPropertySearch();
    }
    else if (event.key === "Backspace") {
      this.isBackSpace = true;
      this.onPropertySelect(event);
    }
  }

  onInputKeyPress(event) {
    if (event.key === "Enter") {
      this.onPropertySearch();
    }
  }

  onKeyUp(event) {
    if (this.searchCriteria?.Address?.length == 0 && this.isBackSpace && this.addressPreviousVal?.length > 0) {
      this.onPropertySearch();
      this.isBackSpace = false
    }

    this.addressPreviousVal = this.searchCriteria.Address;
  }


  bindSubCategoroes(event) {
    this.inputSubCategory = [];
    if (this.inputAssetTypes.length > 0) {
      var that = this;
      var ids = this.inputAssetTypes.map(x => x.id);
      this._commonService.getSubcategoryList(ids).subscribe(res => {
        if (res.length > 0) {
          that.inputSubCategory = res.map(o => {
            return { id: o["Id"], name: o["Name"], typeId: o["MasterId"], checked: (this.searchCriteria?.SubCategories?.length > 0 && this.searchCriteria?.SubCategories?.findIndex(f => f == o["Id"]) > -1 ? true : false) };
          });

          that.searchCriteria.SubCategories = that.searchCriteria?.SubCategories?.filter(o => that.inputSubCategory.some(({ id, itemName }) => o === id));
        }
        else {
          that.searchCriteria.SubCategories = [];
        }
        this.buildTags(event, 13);
        this.bindInputAssetTypesToSubcategory();
      });
    }
    else {
      this.inputSubCategory = [];
      this.searchCriteria.SubCategories = [];
      this.buildTags(event, 13);
    }


  }

  saveSearchLink() {
    if (this.isUserLoggedIn) {
      let searchName = this.user.Guid + this.randomString(6);
      this.saveSearchInputModel.SearchName = searchName;

      if (this._validationService.IsinValid(this.saveSearchInputModel.SearchName)) {
        let searchName = this.user.Guid + this.randomString(6);
        this.saveSearchInputModel.SearchName = searchName;
      }
      else {
        this.saveSearchInputModel.PropertySearchCriteria = this.searchCriteria;
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        this.saveSearchInputModel.UserId = loggedUserDetails.Id;
        this.saveSearchInputModel.Source = 'ShareLink';
        this._propertyListingService.saveSearch(this.saveSearchInputModel).subscribe(response => {
          this.saveSearchResponse = response;
          if (this.saveSearchResponse.Success) {
            this.saveSearchEmitter.emit();
            this.saveSearchInputModel.SearchName = null;
            this._propertyListingService.UpdateSaveSearch(true); //this code will trigger save seach binding function in the header component to re bind the save search
            this.copyLink(this.saveSearchResponse.Guid);
          }
          else {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Something happend,please try again later', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
          }
        });
      }
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to save your searches", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }

  }

  randomString(length) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  currentsharedurl: string = '';
  currentsharedtext: string = '';

  copyLink(saveSearchGuid: string) {
    if (saveSearchGuid != null && saveSearchGuid != '') {
      document.getElementById('copyurlhref').setAttribute('href', (this.Site_URL + saveSearchGuid));
      const from = document.getElementById('copyurlhref');
      from.removeAttribute('href');
      from.removeAttribute('href');
      from.setAttribute('href', (this.Site_URL + saveSearchGuid));
      from.textContent = this.Site_URL + saveSearchGuid;
      var selection = window.getSelection();
      var range = document.createRange();
      from.style.display = 'block';
      range.selectNodeContents(from);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      var successful = document.execCommand('copy');
      document.getElementById('copyurlhref').style.display = 'none';
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copy url command was ' + msg);
      this._toastService.addToast({ title: 'Success', msg: 'Search Copied successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    }

  }

  onModelChange(type: number): void {
    // Map the selected objects to an array of ids
    if (type == 3) {
      this.searchCriteria.AssetTypes = this.selectedAssetTypes?.map(item => item.id);
    }
  }

  compareById(item1: any, item2: any): boolean {
    return item1?.Id === item2?.Id;
  }
  onInputKeyPressevent(event: KeyboardEvent): void {
    const value = event.target as HTMLInputElement;
    if (value && value.value.indexOf('.') !== -1 && event.key === '.') {
      event.preventDefault(); // Prevent entering multiple decimal points
    }
  }

  displayFn(item: any): string {
    return item ? item.PropertyName : '';
  }
  displayTenantFn(item: any): string {
    return item ? item.PropertyName : '';
  }
  trackByIndex(index: number, item: any): number {
    return index;
  }

  citiesList: ICities[];
  bindCity(stateId: any[]) {
    if (stateId != null && stateId.length > 0) {
      let currentCities = stateId.join(',');
      this._commonService.getCitiesListOfStates(currentCities).subscribe(response => {
        this.citiesList = response.map(o => {
          return { Id: o.Id, Name: o.CityName, StateId: o.StateId };
        });

        if (this.searchCriteria.CityId != null && this.searchCriteria.CityId != undefined) {
          if (this.citiesList.findIndex(f => f.Id == this.searchCriteria.CityId) <= -1) {
            this.searchCriteria.CityId = null;
          }
        }
      });
    }
  }

  modalRefAdvanceFilter: BsModalRef;
  openModalAdvanceFilter(template: TemplateRef<any>, classes) {
    this.originalSearchCriteria = structuredClone(this.searchCriteria);
    this.modalRefAdvanceFilter = this.modalService.show(template, { class: classes });
    this.tenantFilterTags = [];
    if (this.searchCriteria.TenantAddress != null && this.searchCriteria.TenantAddress != undefined) {
      let currentTenants = this.searchCriteria.TenantAddress.filter(f => f.AddressType == 1);
      if (currentTenants != null && currentTenants != undefined && currentTenants.length > 0) {
        currentTenants.forEach(x => {
          this.tenantFilterTags.push(
            {
              Id: 1,
              Value: x.Address
            });
        });
      }
    }
    this.searchCriteria.TenantsNames = this.searchCriteria.TenantAddress;
    if (this.searchCriteria.States != null && this.searchCriteria.States != undefined) {
      this.searchCriteria.AdvanceFilterStates = this.searchCriteria.States;
    }
    if (this.searchCriteria.CityId != null && this.searchCriteria.CityId != undefined && this.searchCriteria.CityId > 0) {
      this.searchCriteria.CityId = this.searchCriteria.CityId;
    }
    else {
      this.searchCriteria.CityId = null;
    }
  }

  setOrginalSearchCriteria() {
    this.searchCriteria = this.originalSearchCriteria;
    this.rentValidation = "";
    this.buildsizeValidation = "";
    this.yearbuiltValidation = "";
    this.rentescalationValidation = "";
    this.tenantFilterTags = [];
  }

  bindInputAssetTypesToSubcategory() {

    this.inputAssetTypes.forEach(x => {
      if (this.inputSubCategory != null && this.inputSubCategory != undefined && this.inputSubCategory.length > 0) {
        let currentSubcategory = this.inputSubCategory.filter(f => f.typeId == x.id);
        if (currentSubcategory != null && currentSubcategory != undefined && currentSubcategory.length > 0) {
          x.subCategory = currentSubcategory;
        }
      }
    });
  }

  isExpandCategory: boolean[] = [];
  expandTypes(group: any) {
    console.log("expanding dropdown", group);
    this.isExpandCategory[group.id] = !this.isExpandCategory[group.id];    // expand only selected parent dropdown category with that childs
  }

  toggleParent(event: any, group: any) {
    group.checked = event.checked;
    this.selectedAssetTypes = this.inputAssetTypes.filter(f => f.checked).map(i => i.id);
    this.searchCriteria.AssetTypes = this.selectedAssetTypes;
    this.buildTags(null, 3);
    if (event.checked) {
      group.subCategory.forEach(child => {
        child.checked = true;
      });
    } else {
      group.subCategory.forEach(child => {
        child.checked = false;
      });
    }
    let subcategories = this.inputAssetTypes
      .flatMap(group => group.subCategory) // flatten all subcategories
      .filter(sub => sub.checked).map(x => x.id);
    if (this.inputAssetTypes != null && this.inputAssetTypes.length > 0) {
      this.searchCriteria.SubCategories = subcategories;
    }
    else {
      this.searchCriteria.SubCategories = [];
    }
    this.buildTags(null, 13);
  }

  togglechild(event: any, item: any) {
    item.checked = event.checked;
    let subcategories = this.inputAssetTypes
      .flatMap(group => group.subCategory) // flatten all subcategories
      .filter(sub => sub.checked).map(x => x.id);
    this.searchCriteria.SubCategories = subcategories;
    this.buildTags(null, 13);


  }

  setSubcategorytoFalse() {
    let subcategories = this.inputAssetTypes
      .flatMap(group => group.subCategory) // flatten all subcategories
      .filter(sub => sub.checked);
    if (subcategories != null && subcategories != undefined && subcategories.length > 0) {
      subcategories.forEach(child => {
        child.checked = false;
      });
    }
  }

  setassetTypetoFalse() {
    let assetTypes = this.inputAssetTypes // flatten all subcategories
      .filter(sub => sub.checked);
    if (assetTypes != null && assetTypes != undefined && assetTypes.length > 0) {
      assetTypes.forEach(child => {
        child.checked = false;
      });
    }
  }

  onApplyFilterClick(IsFromApply: boolean) {
    let IsValid = true;
    if (IsFromApply) {
      IsValid = this.validateAdvanceFilter();
    }

    if (IsValid) {
      if (this.searchCriteria.TenantsNames != null && this.searchCriteria.TenantsNames != undefined && this.searchCriteria.TenantsNames.length > 0) {
        this.searchCriteria.TenantAddress = [];
        this.searchCriteria.TenantsNames.forEach(child => {
          this.searchCriteria.TenantAddress.push(child);
        });
      }

      if (this.searchCriteria.TenantFullAddress != null && this.searchCriteria.TenantFullAddress != undefined) {
        this.searchCriteria.Address = this.searchCriteria.TenantFullAddress.Address
        this.searchCriteria.AddressType = this.searchCriteria.TenantFullAddress.AddressType
        this.searchCriteria.AddressTypeId = this.searchCriteria.TenantFullAddress.AddressTypeId
        this.searchCriteria.AddressTypeName = this.searchCriteria.TenantFullAddress.AddressTypeName
      }


      if (this.searchCriteria.AdvanceFilterStates != null && this.searchCriteria.AdvanceFilterStates != undefined && this.searchCriteria.AdvanceFilterStates.length > 0) {
        this.searchCriteria.States = this.searchCriteria.AdvanceFilterStates;
      }
      else {
        this.searchCriteria.States = [];
      }
      this.buildTags(null, 23);
      this.buildTags(null, 22);
      this.buildTags(null, 9);
      this.buildTags(null, 1);
      this.buildTags(null, 10);
      this.buildTags(null, 6);
      this.buildTags(null, 15);
      this.buildTags(null, 4)
      this.buildTags(null, 8)
      this.buildTags(null, 19);
      this.buildTags(null, 7)
      this.buildTags(null, 21)
      this.buildTags(null, 12)
      this.buildTags(null, 14)
      this.buildTags(null, 20);

      if (IsFromApply) {
        this.modalRefAdvanceFilter.hide();
      }

      this.onPropertySearch();
    }
  }

  onSearchChange() {
    const search = this.searchPropertyType.toLowerCase().trim();

    if (!search) {
      this.inputAssetTypes = [...this.originalAssetTypes];
      return;
    }

    this.inputAssetTypes = this.originalAssetTypes
      .map(group => {
        const parentMatches = group.itemName.toLowerCase().includes(search);

        const filteredChildren = group.subCategory?.filter(child =>
          child.name.toLowerCase().includes(search)
        ) || [];

        if (parentMatches || filteredChildren.length > 0) {
          // Optionally auto-expand matched groups
          this.isExpandCategory[group.id] = true;

          return {
            ...group,
            subCategory: parentMatches ? group.subCategory : filteredChildren
          };
        }

        return null;
      })
      .filter(group => group !== null);
  }
  addState() {
    this.searchCriteria.AdvanceFilterStates = this.searchCriteria.States;
    this.bindCity(this.searchCriteria.States);
  }

  bindSavedSearch() {
    if (this.searchCriteria.Address != null && this.searchCriteria.AddressType != null) {
      let address
        = {
        Address: this.searchCriteria.Address,
        AddressTypeId: this.searchCriteria.AddressTypeId,
        AddressType: this.searchCriteria.AddressType,
        AddressTypeName: this.searchCriteria.AddressTypeName
      };
      if (this.searchCriteria.AddressType == 4) {
        this.searchCriteria.TenantFullAddress = address;
      }
      else if (this.searchCriteria.AddressType == 1) {
        this.searchCriteria.TenantAddress.push(address);
      }
      if (this.searchCriteria.AddressType != 4) {
        this.searchCriteria.Address = null;
        this.searchCriteria.AddressType = null;
        this.searchCriteria.AddressTypeId = null;
        this.searchCriteria.AddressTypeName = null;
      }
    }
  }

  getFilterTagText(tag: any) {
    var result = '';
    let filteredTagIds = [1, 3, 4, 9, 10, 12, 13, 14, 19, 23]
    if (tag) {
      if (filteredTagIds.findIndex(f => f == tag.Id) > -1) {
        var type = tag.Value.split(',');
        var displayItems = type.slice(0, 4);
        var remaining = type.length - 4;
        result = displayItems.join(', ');
        if (remaining > 0) {
          result += ', +' + remaining + ' more';
        }
      }
      else {
        result = tag.Value;
      }
    }
    return result;
  }

  uncheckAll(): void {
    if (this.inputAssetTypes != null && this.inputAssetTypes.length > 0) {
      this.inputAssetTypes.forEach(parent => {
        parent.checked = false;
        if (parent.subCategory != null && parent.subCategory != undefined && parent.subCategory.length > 0) {
          parent.subCategory.forEach(child => {
            child.checked = false;
          });
        }
      });
    }
  }

  checkState() {
    if (this.searchCriteria?.AdvanceFilterStates != null && this.searchCriteria?.AdvanceFilterStates != undefined && this.searchCriteria?.AdvanceFilterStates.length > 0) {

    }
    else {
      this._toastService.addToast({ title: 'Error', msg: 'Please Select the State', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }

  clearSearchFromListing() {
    this.filterTags = [];
    var input = $(".search-field-input");
    input.each(function (item) {
      $(input[item]).val("");
    });
    // if (this.dropdownTenants != undefined && this.dropdownTenants != null) {
    //   this.dropdownTenants.clearSearch();
    // }
    this.searchCriteria.IsSearchButtonClicked = false;
    this.Shared.resetClicked(true);
    localStorage.removeItem("LatFrom");
    localStorage.removeItem("LatTo");
    localStorage.removeItem("LongTo");
    localStorage.removeItem("LongFrom");
    localStorage.removeItem("LatFromDislike");
    localStorage.removeItem("LatToDislike");
    localStorage.removeItem("LongToDislike");
    localStorage.removeItem("LongFromDislike");
    localStorage.removeItem("LatFromFavorite");
    localStorage.removeItem("LatToFavorite");
    localStorage.removeItem("LongToFavorite");
    localStorage.removeItem("LongFromFavorite");
    localStorage.removeItem("searchCriteria_buy");
    this.defaultSearchCriteriaValues();
    this.searchInformationValidation();
    this._propertyListingService.criteria = this.searchCriteria;
    if (this.IsValid == true) {
      this.searchCriteria.IsTileList = true;

      this.searchCriteria.LoggedInUserId = this.user.Id;
    }
    else {
      return false;

    }
  }

  setBuildTags(searchValue) {
    this._propertyListingService.getUserSavedSearchCriteria(searchValue).subscribe((response: IPropertySearchCriteria) => {
      this.searchCriteria = response;
      this.bindSavedSearch();
      for (let i = 0; i <= 24; i++) {
        if (i == 1) {
          this.buildTags(null, i, this.searchCriteria.TenantAddress);

        }
        else {
          this.buildTags(null, i);

        }
      }

      if (this.searchCriteria?.AssetTypes.length > 0) {
        this.searchCriteria?.AssetTypes.forEach(x => {
          if (this.inputAssetTypes.length > 0 && this.inputAssetTypes.findIndex(f => f.Id == x) > -1) {
            let currentType = this.inputAssetTypes.find(f => f.Id == x);
            if (currentType != null) {
              currentType.checked = true;
            }
          }
        });
      }
      if (this.searchCriteria?.SubCategories.length > 0) {
        let subcategories = this.inputAssetTypes
          .flatMap(group => group.subCategory) // flatten all subcategories
          .filter(sub => this.searchCriteria?.SubCategories.findIndex(f => f == sub.id) > -1);
        if (subcategories.length > 0) {
          subcategories.forEach(x => {
            x.checked = true;
          });
        }
      }
      this.searchCriteria.IsSavedSearch = true;
      this.searchCriteria.FilterTagCount = this.filterTags != null && this.filterTags?.length > 0 ? this.filterTags.length : 0;
      this.propertySearchCriteria.emit(this.searchCriteria);
      this.searchCriteria.IsSavedSearch = false;
    });
  }

  openSaveSearchModal() {
    document.getElementById("savesearch-modal").click();

  }
}


